import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
const notifications = [{
  flagCode: 'us',
  countryName: 'United States',
  location: 'New York, USA',
  name: 'Sarah Jenkins',
  initials: 'SJ',
  time: '5 minutes ago'
}, {
  flagCode: 'gb',
  countryName: 'United Kingdom',
  location: 'London, UK',
  name: 'David Smith',
  initials: 'DS',
  time: '12 minutes ago'
}, {
  flagCode: 'ca',
  countryName: 'Canada',
  location: 'Toronto, Canada',
  name: 'Emily Chen',
  initials: 'EC',
  time: '18 minutes ago'
}, {
  flagCode: 'au',
  countryName: 'Australia',
  location: 'Sydney, Australia',
  name: 'Michael Brown',
  initials: 'MB',
  time: '27 minutes ago'
}, {
  flagCode: 'ie',
  countryName: 'Ireland',
  location: 'Dublin, Ireland',
  name: 'Jessica Walsh',
  initials: 'JW',
  time: '41 minutes ago'
}];
export function PurchaseNotifications() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    const initialTimer = setTimeout(() => setIsVisible(true), 3000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (isDismissed || !isVisible) return;
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        if (!isDismissed) {
          setCurrentIndex(prev => (prev + 1) % notifications.length);
          setIsVisible(true);
        }
      }, 1500);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, isDismissed, currentIndex]);
  if (isDismissed) return null;
  const current = notifications[currentIndex];
  return <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 pointer-events-none w-full px-4 flex justify-center" aria-live="polite" data-id="element-237" data-mp="3j9n9wxxavv42">
      <AnimatePresence mode="wait" data-id="element-238" data-mp="3krc5pqayy9z6">
        {isVisible && <motion.div key={currentIndex} initial={{
        opacity: 0,
        y: 50,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.9
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-cream-light border border-gold rounded-xl p-3.5 shadow-[0_10px_30px_rgba(26,26,26,0.18)] w-full max-w-[360px] pointer-events-auto relative" data-id="element-239" data-mp="3pqfaraqy8g75">
            <button type="button" onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-ink-muted hover:text-ink transition-colors" aria-label="Dismiss notification" data-id="element-240" data-mp="36sun26zx7no4">
              <XIcon size={14} data-id="element-241" data-mp="2j2qgprvcl9tf" />
            </button>

            <div className="flex items-center gap-3" data-id="element-242" data-mp="2n30w1v515cky">
              <div className="relative shrink-0" data-id="element-243" data-mp="2n2ivimbc4c78">
                <div className="w-11 h-11 rounded-full bg-burgundy text-cream-light flex items-center justify-center font-bold text-sm" data-id="element-244" data-mp="24egnu3qipjqr">
                  {current.initials}
                </div>
                <img src={`https://flagcdn.com/w40/${current.flagCode}.png`} alt={`Flag of ${current.countryName}`} className="absolute -bottom-1 -right-1 w-5 h-5 rounded-full object-cover border-2 border-cream-light shadow" data-id="element-245" data-mp="2df6k18joxc50" />
              </div>

              <div className="flex-1 min-w-0 pr-4" data-id="element-246" data-mp="2ifb1p1wc4cwt">
                <div className="flex items-center gap-1.5 text-[11px] text-ink-muted mb-0.5" data-id="element-247" data-mp="2icf1t80xfe5q">
                  <img src={`https://flagcdn.com/w20/${current.flagCode}.png`} alt="" className="w-4 h-3 rounded-sm object-cover" data-id="element-248" data-mp="2w80mx441hdsv" />
                  <span className="truncate" data-id="element-249" data-mp="361r8o18s7a4v">{current.location}</span>
                </div>

                <p className="text-ink text-[13px] leading-snug" data-id="element-250" data-mp="312wige8hijaq">
                  <span className="font-bold" data-id="element-251" data-mp="3l6c7qsek002l">{current.name}</span>{' '}
                  <span className="text-ink-soft" data-id="element-252" data-mp="3p8737g9szj8g">
                    purchased Hip Hop Dance Instructor Ready
                  </span>
                </p>

                <div className="flex items-center gap-1.5 text-[10px] text-burgundy font-medium mt-1" data-id="element-253" data-mp="3u1iepupk8o6p">
                  <span className="w-1.5 h-1.5 rounded-full bg-burgundy animate-pulse" data-id="element-254" data-mp="2uyvbr5nrpws" />
                  <ShoppingBagIcon size={10} data-id="element-255" data-mp="32acb34ams8co" />
                  <span data-id="element-256" data-mp="369bfmnsga33l">Verified purchase • {current.time}</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}